import { getRawAddEventListener } from '../../../shares/lib/rawEventListener';
import { simulateElements } from './simulateElements';

let timeoutId = undefined as unknown as ReturnType<typeof setTimeout>;

export function renderSimulateIframe(
  container: HTMLElement,
  iframeUrl: string,
) {
  const rawAddEventListener = getRawAddEventListener();
  const messageController = new AbortController();
  const iframeOnLoad = 'Simulate has loaded';
  const iframeTimeoutMs = 30_000;

  return new Promise<HTMLIFrameElement>((resolve, reject) => {
    const iframe = document.createElement('iframe');
    simulateElements.iframe = iframe;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = 'none';
    iframe.src = iframeUrl;
    iframe.hidden = true;

    rawAddEventListener(
      'message',
      (message: MessageEvent) => {
        const isValidOrigin = iframeUrl.startsWith(message.origin);

        if (isValidOrigin && message.data === iframeOnLoad) {
          iframe.hidden = false;
          resolve(iframe);
        }
      },
      { signal: messageController.signal },
    );

    iframe.addEventListener('error', (e) => {
      reject(`An error occurred ${e.message}`);
    });

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      reject('An error occurred. Please try again later.');
    }, iframeTimeoutMs);

    if (container.hidden) {
      container.hidden = false;
    }

    if (container.parentElement?.hidden) {
      container.parentElement.hidden = false;
    }

    container.replaceChildren(iframe);
  }).finally(() => {
    clearTimeout(timeoutId);
    messageController.abort();
  });
}
